import React, { useState } from 'react';
import { VideoPlayer } from './components/VideoPlayer';
import { Timeline } from './components/Timeline';
import { DetailedTimelineView } from './components/DetailedTimelineView';
import { FactCheckPanel } from './components/FactCheckPanel';
import { mockFactChecks } from './data/mockData';
import { LayoutGridIcon, ListIcon } from 'lucide-react';
export function App() {
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [viewMode, setViewMode] = useState<'simple' | 'detailed'>('simple');
  // Real presidential debate video URL (2020 Presidential Debate)
  const debateVideoUrl = 'https://www.youtube.com/watch?v=wW1lY5jFNcQ';
  const handleTimeUpdate = (time: number) => {
    setCurrentTime(time);
  };
  const handlePlayPause = (playing: boolean) => {
    setIsPlaying(playing);
  };
  const handleSeek = (time: number) => {
    setCurrentTime(time);
  };
  const toggleViewMode = () => {
    setViewMode(viewMode === 'simple' ? 'detailed' : 'simple');
  };
  return <div className="min-h-screen bg-gray-100 p-4 md:p-6 lg:p-8" data-id="element-0">
      <div className="max-w-6xl mx-auto" data-id="element-1">
        <header className="mb-6" data-id="element-2">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-3">
            Presidential Debate Fact Checker
          </h1>
          <p className="text-gray-600 mt-2" data-id="element-4">
            2020 Presidential Debate with real-time fact checking
          </p>
        </header>
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5">
          <VideoPlayer url={debateVideoUrl} onTimeUpdate={handleTimeUpdate} onPlayPause={handlePlayPause} seekTo={currentTime} data-id="element-6" />
          <div className="p-4 border-t border-gray-200" data-id="element-7">
            <div className="flex justify-between items-center mb-3" data-id="element-8">
              <h2 className="text-xl font-semibold" data-id="element-9">Fact Check Timeline</h2>
              <button onClick={toggleViewMode} className="flex items-center px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-md transition-colors" aria-label={viewMode === 'simple' ? 'Switch to detailed view' : 'Switch to simple view'} data-id="element-10">
                {viewMode === 'simple' ? <>
                    <ListIcon size={18} className="mr-1" data-id="element-11" />
                    <span data-id="element-12">Detailed View</span>
                  </> : <>
                    <LayoutGridIcon size={18} className="mr-1" data-id="element-13" />
                    <span data-id="element-14">Simple View</span>
                  </>}
              </button>
            </div>
            {viewMode === 'simple' ? <>
                <Timeline currentTime={currentTime} duration={5400} // 90 minutes (typical presidential debate length)
            factChecks={mockFactChecks} onSeek={handleSeek} isPlaying={isPlaying} data-id="element-15" />
                <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-16">
                  <FactCheckPanel factChecks={mockFactChecks} currentTime={currentTime} data-id="element-17" />
                </div>
              </> : <DetailedTimelineView factChecks={mockFactChecks} currentTime={currentTime} onSeek={handleSeek} data-id="element-18" />}
          </div>
        </div>
      </div>
    </div>;
}